import Guid from "common/values/guid/guid";
import moment, { Moment } from "moment";
import UserProfile, { UserProfileJSON } from "users/values/user-profile/user-profile";

export interface UserNetworkConnectionProfileJSON {
  id: string;
  createdDate: string;
  user: UserProfileJSON;
}

export default class UserNetworkConnectionProfile {
  public readonly id: Guid;
  public readonly createdDate: Moment;
  public readonly user: UserProfile;

  constructor(id: Guid, user: UserProfile, createdDate: Moment) {
    this.id = id;
    this.user = user;
    this.createdDate = createdDate;
  }

  public static fromJSON(json: UserNetworkConnectionProfileJSON): UserNetworkConnectionProfile {
    if (!json.id)
      throw new InvalidUserNetworkConnectionProfileError({ id: 'Id is required.' });
    if (!json.user)
      throw new InvalidUserNetworkConnectionProfileError({ user: 'User is required.' });

    const id = Guid.fromJSON(json.id);
    if (!id)
      throw new InvalidUserNetworkConnectionProfileError({ id: 'Invalid id.' });
    return new UserNetworkConnectionProfile(
      id,
      UserProfile.fromJSON(json.user),
      moment(json.createdDate)
    );
  }

  public toJSON(): UserNetworkConnectionProfileJSON {
    return {
      id: this.id.toJSON(),
      user: this.user.toJSON(),
      createdDate: this.createdDate.toISOString()
    };
  }
}

export class InvalidUserNetworkConnectionProfileError extends Error {
  issues: unknown;

  constructor(issues: unknown) {
    super(`Invalid user network connection profile.`);
    this.issues = issues;
  }
}
